import { CapacitorHttp } from '@capacitor/core';
import { VDPLAYER_BASE_URL } from '@/services/offline/vdplayerBaseUrl';

// Busca a transcrição (legendas/frases) do serviço de player vdplayer — o MESMO
// endpoint que o plugin coremedia usa internamente (`getTranscript`). Replicado
// aqui porque a `api` do coremedia é interna ao bundle e não é importável, e
// porque precisamos chamar fora do ciclo do player (durante o download, pra
// cachear offline).
//
// Base URL centralizada em vdplayerBaseUrl.js (compartilhada com o vdplayerPositionSync).
const BASE_URL = VDPLAYER_BASE_URL;

// Retorna o corpo da resposta (`{ frases: [...] }`) ou null se não houver
// transcrição (204/vazio) ou em qualquer falha. Não lança — caller é
// fire-and-forget no download.
//
// CapacitorHttp (não axios), pelo mesmo motivo do vdplayerPositionSync e do
// hlsNativeDownloader: auth.service.js grava o JWT do EAD em
// axios.defaults.headers.common['authorization'] (minúsculo). O axios 0.19 faz
// merge de headers case-SENSITIVE, então `authorization` e o nosso
// `Authorization` sobreviviam os dois, e o XHR os enviava concatenados. O
// MachineKeyHandler do vdplayer faz Guid.TryParse no header inteiro → 401 →
// este catch devolvia null em silêncio e NENHUMA transcrição era cacheada,
// deixando a aba vazia offline sem nenhum sinal de erro.
export async function fetchTranscript (broadcastId, token, customerId) {
  if (!broadcastId) return null;
  try {
    const response = await CapacitorHttp.get({
      url: `${BASE_URL}transcript/${broadcastId}/1`,
      headers: { Authorization: token, CustomerId: String(customerId) },
      // Pré-busca é fire-and-forget no download; um timeout evita request pendurada
      // se o endpoint não responder (não deve segurar nada, mas não deixa lixo).
      connectTimeout: 15000,
      readTimeout: 15000
    });
    if (!response || response.status < 200 || response.status >= 300) return null;
    // CapacitorHttp devolve string quando o servidor não manda content-type JSON.
    let data = response.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { return null; }
    }
    // 204/empty → sem transcrição. Só consideramos válido se vier `frases`.
    if (!data || !data.frases || !data.frases.length) return null;
    return data;
  } catch {
    return null;
  }
}
